import {
  Box,
  Flex,
  Heading,
  LinkAnchor,
  mdBumps,
  PrimaryButton,
  smBumps,
  Status,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { OptionalCover, Quote } from '../../../../domain'
import {
  tCovers,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useOptionalCoverModal } from '../../covers/useOptionalCoverModal'
import { WriskTrans } from '../../trans'

export interface AddOnCardProps {
  coverOption: OptionalCover
  loading?: boolean
  quote: Quote
  onAdd: () => void
}

const tKey = TKey(`components.add-on-card`)

export const AddOnCard: FunctionComponent<AddOnCardProps> = ({
  coverOption,
  loading,
  quote,
  onAdd,
}) => {
  const { t } = useWriskTranslation()

  const amount = coverOption.premium

  const handleLinkMoreClicked = useOptionalCoverModal(quote)

  return (
    <Flex
      id={`addon-card-${coverOption.coverOption}`}
      alignItems='flex-start'
      flexDirection='column'
      mb={smBumps}
      p={mdBumps}
      variant='raised'
      width={1}
    >
      <Status mb={smBumps} variant='info' typoSize='xs'>
        {t(tKey('status'))}
      </Status>
      <Heading mb={smBumps} typoSize='md' variant='h3'>
        {t(tCovers(coverOption.coverOption, 'name'))}
      </Heading>
      <Box mb={mdBumps} width={1}>
        <Typo mb={smBumps} whiteSpace='pre-line'>
          <WriskTrans t={t} i18nKey={tCovers(coverOption.coverOption, 'description')} />
        </Typo>
        {t(tCovers(coverOption.coverOption, 'hint'), { defaultValue: '' }) && (
          <Typo mb={smBumps} whiteSpace='pre-line'>
            <WriskTrans t={t} i18nKey={tCovers(coverOption.coverOption, 'hint')} />
          </Typo>
        )}
        <LinkAnchor
          variant='standalone'
          typoSize='sm'
          onClick={() => handleLinkMoreClicked(coverOption)}
        >
          {t([
            TKey(`components.add-on-selector.add-ons`)(
              `${coverOption.coverOption}.actions.more`,
            ),
            tKey('actions.learn-more'),
          ])}
        </LinkAnchor>
      </Box>

      <PrimaryButton data-testid='add-on-button' loading={loading} onClick={onAdd}>
        {t(tKey('actions.add'), { amount })}
      </PrimaryButton>
    </Flex>
  )
}
